
import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import Loading from 'vue-loading-overlay';
import cartServices from '@/services/cart-services';
import commonService from '@/services/common-services';
@Component({
  components: {
    Loading
  },
})
export default class MainPayService extends Vue {
  private isLoading = false;
  private searchTerm = '';
  private searchSite = 'TAOBAO';
  private products: any[] = [];
  private nextPage: number | null = 1;
  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }

  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }

  get rate() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
  }

  private getSiteName(link) {
    if (!link) { return ''; }
    if (link.includes('1688')) { return '1688'; }
    if (link.includes('taobao')) { return 'Taobao'; }
    if (link.includes('tmall')) { return 'Tmall'; }
    return '';
  }

  private isMobile() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }

  private getCorrectTaobaoUrl(mobileUrl) {
    const url = new URL(mobileUrl);
    const idMatch = url.searchParams.get('id');

    if (!idMatch) {
      return mobileUrl;
    }
    return this.isMobile() || !mobileUrl.includes('taobao.com')
      ? mobileUrl
      : `https://item.taobao.com/item.htm?id=${idMatch}`;
  }

  private getDetailProductUrl(itemUrl) {
    return `/chi-tiet-san-pham.html?itemUrl=${this.extractItemId(itemUrl)}`;
  }

  private extractItemId(url: string): string {
    if (!url) { return ''; }
    try {
      const parsedUrl = new URL(url);
      const host = parsedUrl.hostname;
      if (host.includes('taobao.com') || host.includes('tmall.com')) {
        const id = parsedUrl.searchParams.get('id');
        return id ? `https://${host}/item.htm?id=${id}` : url;
      }
      return url;
    } catch (error) {
      return url;
    }
  }


  private async created() {
    if (!this.rate) {
      await this.getRate();
    }
    if (this.products.length === 0) {
      await this.searchProduct();
    }
  }

  private async getRate() {
    const result = await commonService.exchangeRate();
    if (result && result.status === 200) {
      (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
    }
  }

  private isValidURL(str) {
    try {
      const url = new URL(str);
      const host = url.hostname;
      return host.includes('taobao.com') || host.includes('tmall.com') || host.includes('1688.com');
    } catch (_) {
      return false;
    }
  }

  private async searchProduct() {
    // Kiểm tra xem searchTerm có phải là URL hay không
    if (this.isValidURL(this.searchTerm)) {
      // Nếu là URL, chuyển hướng đến trang chi tiết sản phẩm
      window.open(this.getDetailProductUrl(this.searchTerm), '_blank');
      return;
    }
    // Nếu không phải URL, thực hiện tìm kiếm sản phẩm
    this.products = [];
    this.nextPage = 1;
    await this.loadMoreProducts();
  }

  private async loadMoreProducts() {
    if (this.nextPage === null || this.nextPage > 10 || this.isLoading) {
      return;
    };
    this.isLoading = true;

    const result = await cartServices.searchProducts(this.searchSite, this.searchTerm, this.isMobile(), this.nextPage);
    if (result && result.status === 200 && result.data.data.success) {
      this.products.push(...result.data.data.content);
      this.nextPage = result.data.data.nextPageSize ? this.nextPage + 1 : null;
    }

    this.isLoading = false;
  }

  private onScroll() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {
      this.loadMoreProducts();
    }
  }

  mounted() {
    window.addEventListener('scroll', this.onScroll);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
